export const THRESHOLD_VALUE = 25

export enum PaymentMethods {
  PayPal = 'paypal',
  Payoneer = 'payoneer',
}
